import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonImg,
  IonPage,
  IonProgressBar,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { useContext, useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import NotificationBadgeButton from '../../../components/NotificationBadgeButton';
import { AppContext } from '../../../lib/context/AppContext';
import { CDRTEvent, ICDRTEvent } from '../../../lib/models';
import PageContainer from '../../../components/PageContainer';
import { calendarOutline, mapOutline } from 'ionicons/icons';

interface UserDetailPageProps
  extends RouteComponentProps<{
    eventId: string;
  }> {}

const EventDetailsPage: React.FC<UserDetailPageProps> = ({ match }) => {
  const { apiService } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(true);
  const [cdrtEvent, setCdrtEvent]: [ICDRTEvent | undefined, any] = useState();

  const fetchEvent = () => {
    apiService
      ?.get(`/events/${match.params.eventId}?populate=media,address`)
      .then(
        (response: any) => {
          setCdrtEvent(CDRTEvent(response.data.data));
          setIsLoading(false);
        },
        (error) => {
          setIsLoading(false);
        }
      );
  };

  useEffect(() => {
    if (!cdrtEvent) {
      setIsLoading(true);
      fetchEvent();
    }
  }, [apiService]);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color='primary'>
          {isLoading && <IonProgressBar type='indeterminate'></IonProgressBar>}
          <IonButtons slot='start'>
            <IonBackButton
              defaultHref='/events'
              text={'Indietro'}
            ></IonBackButton>
          </IonButtons>
          <IonTitle>Dettaglio Evento</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        {cdrtEvent?.media?.data?.attributes?.url && (
          <IonImg src={cdrtEvent?.media?.data?.attributes?.url}></IonImg>
        )}
        {cdrtEvent && (
          <PageContainer>
            <h1>{cdrtEvent?.title}</h1>
            <div className='mt-4 flex items-center'>
              {(cdrtEvent?.startDate || cdrtEvent?.endDate) && (
                <IonIcon
                  aria-hidden='true'
                  icon={calendarOutline}
                  className='h-5 w-5 mr-4'
                />
              )}
              <span>
                {cdrtEvent?.startDate && (
                  <span>
                    <span className='text-gray-500 uppercase font-bold text-xs'>
                      Inizio:{' '}
                    </span>
                    <span className='font-bold'>
                      {new Date(cdrtEvent?.startDate).toLocaleDateString()}
                    </span>
                  </span>
                )}
                {cdrtEvent?.startDate && cdrtEvent?.endDate && ' - '}
                {cdrtEvent?.endDate && (
                  <span>
                    <span className='text-gray-500 uppercase font-bold text-xs'>
                      Fine:{' '}
                    </span>
                    <span className='font-bold'>
                      {new Date(cdrtEvent?.endDate).toLocaleDateString()}
                    </span>
                  </span>
                )}
              </span>
            </div>
            {cdrtEvent.address && (
              <div className='flex items-center mt-2'>
                <IonIcon
                  aria-hidden='true'
                  icon={mapOutline}
                  className='h-5 w-5 mr-4'
                />
                <span>
                  {cdrtEvent.address?.street} {cdrtEvent.address?.city} -{' '}
                  {cdrtEvent.address?.zip} ({cdrtEvent.address?.country})
                </span>
              </div>
            )}
            <div className='border-top w-full h-[1px] bg-gray-300 my-4'></div>
            <div
              className='pb-4'
              dangerouslySetInnerHTML={{ __html: cdrtEvent?.description || '' }}
            ></div>
          </PageContainer>
        )}
      </IonContent>
    </IonPage>
  );
};
export default EventDetailsPage;
